<template>
  <div class="contacts">
    <div class="content-box contacts-box">
      <!-- 步骤条 -->
      <div class="contact-title-top">
        <template v-if="formItem.contactId">
          {{
          $t('crm_partner_item_contacts.xiu_gai_lian_xi_ren')
          }}
        </template>
        <template v-else>
          {{
          $t('crm_partner_item_contacts.xin_zeng_lian_xi_ren')
          }}
        </template>
      </div>
      <div class="content-main">
        <!-- 联系人信息 -->
        <div class="role-list">
          <ul>
            <li>
              <div class="item ub formContact-title">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="5">{{$t('crm_partner_item_contacts.xing_ming')}}</el-col>
                  <el-col :span="5">{{$t('crm_partner_item_contacts.zhi_wu')}}</el-col>
                  <el-col :span="5">{{$t('crm_partner_item_contacts.dian_hua')}}</el-col>
                  <el-col :span="9">{{$t('crm_partner_item_contacts.you_xiang')}}</el-col>
                </el-row>
                <!--  -->
              </div>
              <div class="bottom"></div>
            </li>
            <li>
              <div class="item ub">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="5">
                    <el-input
                      v-model="formItem.contactName"
                      :placeholder="$t('crm_partner_item_contacts.qsrlxrmc')"
                      style="width: 100%"
                    ></el-input>
                  </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="formItem.post"
                      :placeholder="$t('crm_partner_item_contacts.qxzlxrzw')"
                      style="width: 100%"
                    ></el-input>
                  </el-col>
                  <el-col :span="5">
                    <el-input
                      v-model="formItem.mobilePhone"
                      :placeholder="$t('crm_partner_item_contacts.qsrlxrdh')"
                      style="width: 100%"
                    ></el-input>
                  </el-col>
                  <el-col :span="9">
                    <el-input
                      v-model="formItem.email"
                      :placeholder="$t('crm_partner_item_contacts.qsrlxryx')"
                      style="width: 100%"
                    ></el-input>
                  </el-col>
                </el-row>
              </div>
            </li>
          </ul>
        </div>
        <div class="role-add-btn" @click="saveContacts">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span v-if="formItem.contactId">{{$t( "page_content_edit_contact")}}</span>
            <span v-else>{{$t('crm_partner_item_contacts.tian_jia_lian_xi_ren')}}</span>
          </div>
        </div>
        <div class="hr"></div>
        <div class="contact-title">{{$t('crm_partner_item_contacts.lian_xi_ren_lie_biao')}}</div>
        <custom-table
          :data="contactList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
           :slots="['action']"
        >
        <!-- 操作列 -->
          <template v-slot:action="scope" >
              <span></span>
              <el-button type="text" size="mini" @click="editContact(scope.row)">{{$t('Common.com_edit')}}</el-button>
              <el-button
                type="text"
                size="mini"
                @click="deleteContact(scope.row.contactId)"
              >{{$t('Common.com_delete')}}</el-button>
            </template>
        </custom-table>
      </div>
    </div>
    <div class="btn-group">
      <el-button
        @click="$emit('previous');"
      >{{$t('crm_partner_item_contacts.sybjbxx')}}</el-button>
      <el-button
        type="primary"
        @click="nextContacts"
      >{{$t('crm_partner_item_contacts.xybglyxx')}}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    partnerId: [String, Number],
    partnerOrgId: [String, Number],
    required: { type: Boolean, default: false }
  },
  data() {
    return {
      businessLicenseImageList: [],
      imageList: [],
      imageIdList: [],
      tableCode: 'company_contact',
      companyId: '',
      companyOrgId: '',
      // 联系人
      formItem: {
        contactName: '',
        post: '',
        mobilePhone: '',
        email: '',
        contactType: 'coopcontact',
      },
      contactList: [],
      // 租赁方ID
      tenterId: '',


    };
  },
  mounted() {
    this.getTableColumn();
    // this.companyId = this.getJump('companyId');
    this.companyId = this.partnerId || '';
    this.companyOrgId = this.partnerOrgId || '';
    this.getContactList();
  },
  methods: {
    getContactList: function () {
      if (!this.companyId || !this.companyOrgId) {
        return;
      }
      this.$getJSON(apis.partnerContact, {
        partnerId: this.companyId,
        partnerOrgId: this.companyOrgId,
      }).then((res) => {
        this.contactList = res.data;
      });
    },

    // 取消
    onCancel: function () {
      this.jump('/customer/renter', { refresh: true }, true);
    },
    // 保存联系人
    saveContacts: function () {
      const emailReg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      // 验证
      const hasEmpty = !this.formItem.contactName
        || !this.formItem.post
        || !this.formItem.mobilePhone;
      if (hasEmpty) {
        const tips = this.$t('crm_partner_item_contacts.qjqtlxrxxtxwz');
        this.$message.error(tips);
        return;
      }
      if (
        this.formItem.mobilePhone.length < 7
        || this.formItem.mobilePhone.length > 13
      ) {
        const tips = this.$t('crm_partner_item_contacts.dhcdyz713gzf');
        this.$message.error(tips);
        return;
      }

      const EmailTest = !emailReg.test(this.formItem.email);
      if (EmailTest) {
        const tips = this.$t('crm_partner_item_contacts.qtxzqdyx');
        this.$message.error(tips);
        return;
      }
      this.formItem.contactType = 'coopcontact'; // 普通联系人
      this.formItem.partnerId = this.companyId; // 联系人id
      this.formItem.partnerOrgId = this.companyOrgId; // 联系人id
      if (this.formItem.contactId) {
        // 修改
        this.$postJSON(apis.partnerContactUpdate, this.formItem).then(() => {
          this.$message({
            message: this.$t('Common.com_modify_success'),
            type: 'success',
          });
          // 清空输入框
          this.clearFormItem();
          // 获取info 联系人
          this.getContactList();
        });
      } else {
        this.formItem.contactType = 'coopcontact'; // 普通联系人
        this.formItem.partnerId = this.companyId; // 联系人id
        this.formItem.partnerOrgId = this.companyOrgId; // 联系人id
        // 新增
        this.$postJSON(apis.partnerContactAdd, this.formItem).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          // 清空输入框
          this.clearFormItem();
          // 获取info 联系人
          this.getContactList();
        });
      }
    },

    // 下一步
    nextContacts: function () {
      if (!this.contactList.length && this.required) {
        this.$message({
          message: this.$t('crm_partner_item_contacts.qtjlxr'),
          type: 'error',
        });
        return;
      }
      this.$emit('success', 4);
    },
    editContact: function (row) {
      this.formItem = { ...row };
    },
    clearFormItem: function () {
      this.formItem = {
        contactName: '',
        post: '',
        mobilePhone: '',
        email: '',
      };
    },

    deleteContact: function (contactId) {
      const tips = this.$t('crm_partner_item_contacts.nqdysclxrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`).then(
            () => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getContactList();
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
// @import "../../../../style/colors.scss";

.contacts {
  height: 100%;
  // position: relative;
  // overflow: auto;
  display: flex;
  // padding:  0 24px;
  flex-direction: column;
  background: #fff;
  box-sizing: border-box;
  // .header-step {
  //   flex: 0 0 80px;
  //   padding: 20px 0;
  // }
  .contacts-box {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 24px;
    overflow-y: auto;
  }
  .contact-title-top {
    padding: 32px 0;
    font-size: 14px;
    font-weight: bold;
    color: rgba(57, 70, 104, 1);
    line-height: 18px;
  }
  .hr {
    border-bottom: 1px solid #e4ebf2;
  }
  .contact-title {
    padding: 32px 0 24px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(57, 70, 104, 1);
    line-height: 18px;
  }
  .role-list {
    margin-bottom: 26px;
    ul {
      // padding: 30px 0 0px;
      // border: 1px solid #e4e4e4;
      li {
        margin-top: 10px;
        // background: #fff;
        border: 0;
        &:first-child {
          margin-top: 0;
          // background: whitesmoke;
        }
      }
    }

    .item {
      // height: 50px;
      // padding: 10px;
      // background: rgba(245, 245, 245, 1);
      // border: 1px solid rgba(228, 228, 228, 1);
      // line-height: 30px;
      font-size: 12px;
      .icon-box {
        line-height: 30px;
        width: 30px;
        margin-left: 10px;
        text-align: center;
        cursor: pointer;
        .icon {
          color: #00afff;
          font-size: 14px;
        }
      }
    }
    .formContact-title {
      font-size: 12px;
      padding: 6px 0;
      font-weight: bold;
    }
  }

  .role-add-btn {
    background: rgba(249, 249, 253, 1);
    border: 1px dashed #e4e4e4;
    line-height: 32px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    margin-bottom: 32px;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
  .btn-group {
    border-top: 1px solid #eef2f8;
    padding: 16px 0 16px 24px;
    height: 60px;
    z-index: 1;
    -webkit-box-flex: 0;
    flex: 0 0 60px;
  }
}
</style>
